import { useFetch } from '@hn-front/utils';
var useAuth = function () {
    return useFetch('/api/auth');
};
export { useAuth };
